export enum OrderMissingAssignmentType {
  GOODS_WITHOUT_VEHICLE = 'goodsWithoutVehicle',
  LOADED_TRAILER_WITHOUT_VEHICLE = 'loadedTrailerWithoutVehicle',
  ORDER_WITHOUT_DRIVER = 'orderWithoutDriver',
}
